import Modal from "../../../components/Modal";
import ModalWrapper from "../../../components/ModalWrapper";
import { Trans } from "@lingui/macro";
import { AutoColumn } from "../../../components/Column";
import { useCallback, useMemo,useEffect, useState } from "react";
import * as jose from 'jose'
import useWeb3 from '../../../hooks/useWeb3';
import styled from "styled-components";
import NumericalInput from "../../../components/NumericalInput";
import AddressInput from '../../../components/AddressInput';
import Row from "../../../components/Row";
import { useWallet } from "use-wallet";

import { ButtonLight, ButtonPrimary } from "../../../components/Button";
import Loader from "../../../components/Loader";

import { SecondsToTime,fromAmount, toAmount } from "../../../utils/amount";
import Big from "big.js";
import { ZERO_ADDRESS } from '../../../utils/ethereum';
const InputText = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const InputAddress = styled(AddressInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const TokenWrapper = styled.div`
 word-wrap: break-word;
 overflow-wrap: break-word;
  width: 350px;
  font-size: 14px;
`;
const LabelWrapper = styled.div`
  font-size: 14px;
`;

const Symbol = styled.div`
  margin-left: 8px;
`;

const BalanceWrapper = styled.div`
  font-size: 14px;
`;

function CreateApiKeyModal({ isOpen, setIsOpen }) {
  const { account,chainId } = useWallet();
  const web3 = useWeb3();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("365");
  const [token, setToken] = useState("");
  


  const handleOnToken = useCallback(async () => {
      setToken('');
      const validtime=86400*(1*value || 0);
      const TokenPwd = '123';
      const currentTimeInMilliseconds = new Date().getTime();
      const currentTimeInSeconds = Math.floor(currentTimeInMilliseconds / 1000);
      const message = 'Expiration Time:'+SecondsToTime(currentTimeInSeconds+validtime);
      const sign = await web3.eth.personal.sign(message, account, null);
      console.log('sign:', sign);
      
      const secret = new TextEncoder().encode(
        TokenPwd,
      );

      const token = await new jose.CompactSign(
        new TextEncoder().encode(JSON.stringify({message,signature:sign})),
      ).setProtectedHeader({ alg: 'HS256' }).sign(secret)
        
      setToken(token);
      //console.log('Generated JWT:', token);

  }, [ value,web3,account ]);



  return (
    <Modal isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
   
        <ModalWrapper
          title={<Trans>Create Key</Trans>}
          toggleWalletModal={() => setIsOpen(false)}
        >
          <AutoColumn gap={"24px"}>
            <AutoColumn gap={"sm"}>
              <LabelWrapper>
                <Trans>Validity Period(Day)</Trans>
              </LabelWrapper>

              <Row>
                <InputText
                  disabled={true}
                  value={value}
                  onUserInput={setValue}
                />
                <Symbol>{'Days'}</Symbol>
              </Row>

              <BalanceWrapper>
                <Trans>
                  Token:
                </Trans>
    
              </BalanceWrapper>
              <TokenWrapper >{token}</TokenWrapper>

            </AutoColumn>
           
              <ButtonLight disabled={loading} onClick={handleOnToken}>
                {loading && <Loader /> } <Trans>Create Key</Trans>
              </ButtonLight>
            
          </AutoColumn>
        </ModalWrapper>
   
    </Modal>
  );
}

export default CreateApiKeyModal;
